import { render, staticRenderFns } from "./use-client.vue?vue&type=template&id=23c31d34"
import script from "./use-client.vue?vue&type=script&lang=js"
export * from "./use-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports